import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`If two users have the same distinct ID, their data is merged and they are considered one user in PostHog. Two common ways this can happen are:`}</p>
    <ul>
      <li parentName="ul">{`Your logic for generating IDs does not generate sufficiently strong IDs and you can end up with a clash where 2 users have the same ID.`}</li>
      <li parentName="ul">{`There's a bug, typo, or mistake in your code leading to most or all users being identified with generic IDs like `}<inlineCode parentName="li">{`null`}</inlineCode>{`, `}<inlineCode parentName="li">{`true`}</inlineCode>{`, or `}<inlineCode parentName="li">{`distinctId`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`PostHog also has built-in protections to stop the most common distinct ID mistakes. See the `}<a parentName="p" {...{
        "href": "/docs/data/identify#what-happens-if-you-call-identify-or-alias-with-invalid-inputs"
      }}>{`FAQ`}</a>{` at the end of this page for more details.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      